(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-no-results-dlp"] && !Shopify.designMode) return;
  try {
    document.querySelector('.collection-results-wrapper:nth-child(2n)').closest('.layout-top.section__blocks').style.display = "flex";
  } catch(e) { console.error(e); }
})();

})();
